import AzureSubscriptionCSP from "../../models/csp/AzureSubscriptionCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  methods: {
    getAzureSubscriptionsCSP: async function (
      customerId: string,
      azurePlanId: string
    ): Promise<AzureSubscriptionCSP[]> {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${customerId}/subscriptions/${azurePlanId}/azureEntitlements`
      );
      return res.items
        .filter(azSub => azSub.status == "active")
        .map(
          azSub =>
            new AzureSubscriptionCSP({
              id: azSub.id,
              azureSubscriptionName: azSub.friendlyName,
              azurePlanId: azSub.subscriptionId, // Refers to Azure Plan Id, but is considered as any other Microsoft "Subscription" Id
              status: azSub.status
            })
        );
    }
  }
};
